import {defineSlotRecipe} from '@chakra-ui/react3'

const colorWorldVariants = {
    cream: {badge: {backgroundColor: 'secondary.cream', color: 'text.on-media.primary'}},
    malva: {badge: {backgroundColor: 'secondary.malva', color: 'text.on-media.primary'}},
    terracotta: {badge: {backgroundColor: 'secondary.terracotta', color: 'text.on-media.primary'}},
    fjordblue: {badge: {backgroundColor: 'secondary.fjordBlue', color: 'text.on-media.primary'}},
    cherry: {badge: {backgroundColor: 'secondary.cherry', color: 'text.on-media.primary'}},
    pinegreen: {badge: {backgroundColor: 'secondary.pineGreen', color: 'text.on-media.primary'}},
    sunflower: {badge: {backgroundColor: 'secondary.sunflower', color: 'primary.base.black'}}
}

export const PROMOTION_BADGE_COLOR_WORLDS = Object.keys(colorWorldVariants)

export default defineSlotRecipe({
    slots: ['badge'],
    base: {
        badge: {
            whiteSpace: 'nowrap',
            borderRadius: 'xs',
            paddingX: 'spacing-8',
            paddingY: 'spacing-2',
            textStyle: 'body.xsmall',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },

    variants: {
        variant: {
            deal: {
                badge: {
                    backgroundColor: 'background.actions.secondary', // black
                    color: 'text.primary-inverted'
                }
            },
            new: {
                badge: {
                    backgroundColor: 'secondary.cream', // cream
                    color: 'text.on-media.primary'
                }
            },
            productPromo: {
                badge: {
                    backgroundColor: 'secondary.malva', // malva
                    color: 'text.on-media.primary'
                }
            },
            promotions: {
                badge: {
                    backgroundColor: 'secondary.terracotta', // terracotta
                    color: 'text.on-media.primary'
                }
            }
        },
        colorWorld: colorWorldVariants
    }
})
